import { Paper, Center, Loader, Text, Stack, ThemeIcon } from "@mantine/core";
import { IconActivity, IconMessage } from "@tabler/icons-react";

import { useGetEventsByUserIdQuery } from "../../api/event.api";
import { EventType } from "../../models/event.models";
import { EventList } from "../Shared/EventList";

interface UserEventListProps {
	userId: string;
	comments: boolean;
}

export const UserEventList = ({ userId, comments }: UserEventListProps) => {
	const { data: events, isLoading } = useGetEventsByUserIdQuery(userId);

	if (isLoading) return <>
		<Center>
			<Loader size="sm" mt="lg" />
		</Center>
	</>;

	if (!events || !events.length || events.filter(event => event.EventType !== EventType.Read).length === 0) return  <>
		<Stack align="center" justify="center" mt={4} mb="lg" px="sm">
			<ThemeIcon size={60} radius={60} color="var(--mantine-color-gray-5)" variant="light">
				{comments ? <IconMessage size={32} /> : <IconActivity size={32} />}
			</ThemeIcon>
			<Text c="var(--mantine-color-gray-5)" fz="sm" style={{ textAlign: 'center' }} lineClamp={1}>No {comments ? "comments" : "recent activity"} for this user.</Text>
		</Stack>
	</>

	return (
		<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
			<EventList events={events ?? []} commentsOnly={comments} showSource={true} showDividers={true} />
		</Paper>
	);
};